module.exports = __webpack_public_path__ + "images/arval_small2466174bd93bf7c8aa1c350c5efcd24e.png";